
<div class="relative pt-8 bg-black">
	<button (click)="closeVideoDialog()" class="absolute top-1 right-2 z-10">
		<span class="material-symbols-outlined">
			close
		</span>
	</button>
	<iframe style="z-index: 1;"
			width="380"
			height="480"
			[src]="data"
			title="YouTube video player"
			frameborder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;"
			allowfullscreen></iframe>
</div>
